import {
  doc,
  onSnapshot,
  FirestoreError,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../firebase";
import { EntityGet, EntityServerGet, OnSnapshotDocService } from "../types";
import { Workflow } from "./types";
import { transformMetadata, processTimestampFields } from "../utils";

export type WorkflowOnSnapshotDocService<T> = (
  id: string,
  callback: (doc: T) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotDoc: WorkflowOnSnapshotDocService<EntityGet<Workflow>> = (
  id,
  callback,
  onError
) => {
  const docRef = doc(db, `/workflow/${id}`);
  return onSnapshot(
    docRef,
    (docSnap) => {
      if (docSnap.exists()) {
        callback(
          processTimestampFields(
            transformMetadata(
              {
                ...docSnap.data(),
                id: docSnap.id,
              } as EntityServerGet<Workflow>,
              docSnap.metadata
            )
          ) as EntityGet<Workflow>
        );
      }
    },
    onError
  );
};

export default onSnapshotDoc;
